import { Observable } from "rxjs/Observable"
import { push } from "react-router-redux"

import {
    ADD_FEED_PREVIEW_TYPING,
    ADD_FEED_ANALYSE_REQUEST,
    ADD_FEED_APPLY_MODEL_UPDATE,
    ADD_FEED_CANCEL_MODEL_UPDATE,
    ADD_FEED_MODERATE,
    ADD_FEED_CLOSE
} from "../actions/action-types"
import {
    addFeedPreview,
    addFeedAnalyseRequest,
    addFeedAnalyseResponse
} from "../actions/add-feed-actions"
import {
    moderationAnalyseRequest,
    moderationItemSaveRequest,
    moderationItemRequest
} from "../actions/moderation-feed-actions"
import {
    toWebLink,
    NOT_A_WEB_LINK_MESSAGE
} from "./default-epics/epic-utils"

export const requestFeedPreviewEpic = (action$, { getState }) =>
    action$
        .ofType(ADD_FEED_PREVIEW_TYPING)
        .debounceTime(500)
        .mergeMap(({ previewURL }) => {
            // Preview and analyse the normalised link (e.g. with https:// added) so the input shows what was submitted.
            const link = toWebLink(previewURL)
            let actions = [
                addFeedPreview(
                    link || previewURL,
                    getState().authentication.token
                )
            ]
            if (link) {
                actions = [...actions, addFeedAnalyseRequest(link, false)]
            } else if (previewURL) {
                // Fail fast with an actionable message instead of round-tripping input the API can't scrape.
                // Same shape as an API error response, so it surfaces through the existing error display.
                const notAWebLinkResponse = addFeedAnalyseResponse({
                    data: {},
                    error: new Error(NOT_A_WEB_LINK_MESSAGE)
                })
                actions = [...actions, notAWebLinkResponse]
            }
            return Observable.of(...actions)
        })

export const requestFeedAnalyseEpic = action$ =>
    action$
        .ofType(ADD_FEED_ANALYSE_REQUEST)
        .map(({ data, isPersisting, callbackActionCreator }) =>
            moderationAnalyseRequest(
                data,
                "link",
                isPersisting,
                false,
                callbackActionCreator
            )
        )

export const requestAddFeedKnowledgeUpdateEpic = (action$, { getState }) =>
    action$.ofType(ADD_FEED_APPLY_MODEL_UPDATE).map(() => {
        const {
            activeId,
            updateModel,
            imageToUpload,
            previewURL
        } = getState().presentation.addFeed
        if (!activeId) {
            return addFeedAnalyseRequest(previewURL, true)
        }
        return moderationItemSaveRequest(
            activeId,
            updateModel.toJS(),
            imageToUpload,
            addFeedAnalyseResponse
        )
    })

export const cancelAddFeedKnowledgeUpdateEpic = (action$, { getState }) =>
    action$
        .ofType(ADD_FEED_CANCEL_MODEL_UPDATE)
        .map(() =>
            moderationItemRequest(
                getState().presentation.addFeed.activeId,
                false,
                addFeedAnalyseResponse
            )
        )

export const requestAddFeedKnowledgeModerateEpic = (action$, { getState }) =>
    action$
        .ofType(ADD_FEED_MODERATE)
        .map(({ moderation, rejection_reason }) => {
            const {
                activeId,
                updateModel,
                imageToUpload
            } = getState().presentation.addFeed
            const moderatedUpdateModel = updateModel
                .set("approved", moderation)
                .set("rejection_reason", rejection_reason)
            return moderationItemSaveRequest(
                activeId,
                moderatedUpdateModel,
                imageToUpload,
                addFeedAnalyseResponse
            )
        })

export const addFeedCloseEpic = action$ =>
    action$.ofType(ADD_FEED_CLOSE).map(() => push("/knowledge"))
